<div class="modal-holder">
    <div class="modal-header">
        <button type="button" class="close modalClose" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <ng-container>
            <div class="form-group">
                <span class="gridname">Grid Name&nbsp;&nbsp;:&nbsp;&nbsp;</span>
                <input type="text" class="input-width inp" placeholder="Enter a grid name" [(ngModel)]="gridName" maxlength="500"/>&nbsp;&nbsp; <br/>
                <span class="text-danger" *ngIf="!isValid">only valid characters are allowed</span>
            </div>
            <div class="form-group mb-4 align">
                <button type="button" [disabled]="gridName === null || gridName === ''" class="ct-btn primary-btn marg-5" (click)="SaveMarginCalgulator()">
                    Save
                </button>
                <button type="button" class="ct-btn secondary-btn marg-5" (click)="activeModal.close()">
                    Cancel
                </button>
            </div>
        </ng-container>
    </div>

    <div class="spinner-holder" [hidden]="!loading">
        <div class="spinner spinner-border text-primary"></div>
    </div>

</div>